import React from "react";
import { Card, Heading, Box, Flex } from "theme-ui";
import { LiquityStoreState } from "@liquity/lib-base";
import { useLiquitySelector } from "@liquity/lib-react";
import { InfoMessage } from "../../../InfoMessage";
import { UnstakeAndClaim } from "../UnstakeAndClaim";
import { RemainingLQTY } from "../RemainingLQTY";
import { StaticRow } from "../../../Trove/Editor";
import { GT, LP } from "../../../../strings";

const selector = ({ liquidityMiningStake2, liquidityMiningLQTYReward2 }: LiquityStoreState) => ({
  liquidityMiningStake2,
  liquidityMiningLQTYReward2
});

export const Disabled: React.FC = () => {
  const { liquidityMiningStake2, liquidityMiningLQTYReward2 } = useLiquitySelector(selector);
  const hasStake = !liquidityMiningStake2.isZero;

  return (
    <Card>
      <Heading>
        PRINT-INC LP Staking
        <Flex sx={{ justifyContent: "flex-end" }}>
          <RemainingLQTY />
        </Flex>
      </Heading>
      <Box sx={{ p: [2, 3] }}>
        <InfoMessage title="PRINT-INC LP Staking period has finished">
          <Flex>There are no more PRINT rewards left to farm</Flex>
        </InfoMessage>
        {hasStake && (
          <>
            <Box sx={{ border: 1, pt: 3, borderRadius: 3 }}>
              <StaticRow
                label="Stake LP"
                inputId="farm-deposit"
                amount={liquidityMiningStake2.prettify(4)}
                unit={LP}
              />
              <StaticRow
                label="Reward"
                inputId="farm-reward"
                amount={liquidityMiningLQTYReward2.prettify(4)}
                color={liquidityMiningLQTYReward2.nonZero && "success"}
                unit={GT}
              />
            </Box>
            <UnstakeAndClaim />
          </>
        )}
      </Box>
    </Card>
  );
};